import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { apolloClient } from '@/vue-apollo'
import { GET_EMPLOYEES, GET_EMPLOYEE } from './moduleEmployeeGraphql'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createEmployee(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('employees', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countEmployees(context) {
    const query = QuerySerialize(context.state.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`employees/count/?${query}`)
        .then(response => {
          context.commit('SET_EMPLOYEES_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchEmployees(context) {
    return new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: GET_EMPLOYEES,
          variables: {
            filter: {
              query: context.state.query,
              skip: context.state.skip,
              limit: context.state.limit,
              sort: context.state.sort
            }
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          context.commit('SET_EMPLOYEES', response.data.employees)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchEmployee(context, employeeId) {
    return new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: GET_EMPLOYEE,
          variables: {
            id: employeeId
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          context.commit('SET_EMPLOYEES', response.data.employees)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchEmployeeUser(context, employeeId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`employees/${employeeId}/user`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchEmployeeBusiness(context, employeeId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`employees/${employeeId}/business`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchEmployeeByUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`employees/?userId=${userId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchEmployeeByBusiness(context, businessId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`employees/?businessId=${businessId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeEmployee({ commit }, employeeId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`employees/${employeeId}`)
        .then(response => {
          commit('REMOVE_RECORD', employeeId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editEmployee(context, employee) {
    return new Promise((resolve, reject) => {
      axios
        .put(`employees/${employee.id}`, employee.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
